import React, { forwardRef, memo } from 'react'

const GiftPrimaryIcon = forwardRef<
  SVGSVGElement,
  React.SVGProps<SVGSVGElement>
>((props, ref) => (
  <svg
    ref={ref}
    width="56"
    height="56"
    viewBox="0 0 56 56"
    fill="none"
    {...props}>
    <circle
      cx="28"
      cy="28"
      r="26.871"
      fill="white"
      stroke="#EEEEEE"
      strokeWidth="2.259"
    />
    <path
      d="M35.7 23.8H20.3C19.9134 23.8 19.6 24.1134 19.6 24.5V27.3C19.6 27.6866 19.9134 28 20.3 28H35.7C36.0866 28 36.4 27.6866 36.4 27.3V24.5C36.4 24.1134 36.0866 23.8 35.7 23.8Z"
      stroke="#78BE20"
      strokeWidth="1.4"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M35 28V34.3C35 34.4904 34.9242 34.6737 34.7899 34.808C34.6556 34.9424 34.4722 35.0182 34.2818 35.0182H21.7C21.5096 35.0182 21.3263 34.9424 21.192 34.808C21.0576 34.6737 20.9818 34.4904 20.9818 34.3V28"
      stroke="#78BE20"
      strokeWidth="1.4"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M28 23.8V35"
      stroke="#78BE20"
      strokeWidth="1.4"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M32.2691 19.5311C33.0863 20.4484 33.1345 21.7239 32.2691 22.4904C30.7895 23.8002 28 23.8002 28 23.8002C28 23.8002 28 21.0106 29.3125 19.5311C30.0763 18.6657 31.3518 18.7139 32.2691 19.5311Z"
      stroke="#78BE20"
      strokeWidth="1.4"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M23.7307 19.5311C22.9135 20.4484 22.8653 21.7239 23.7307 22.4904C25.2103 23.8002 27.9999 23.8002 27.9999 23.8002C27.9999 23.8002 27.9999 21.0106 26.6874 19.5311C25.9236 18.6657 24.6481 18.7139 23.7307 19.5311Z"
      stroke="#78BE20"
      strokeWidth="1.4"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
))

GiftPrimaryIcon.displayName = 'GiftPrimaryIcon'

export default memo(GiftPrimaryIcon)
